var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    {
      attrs: {
        variant: "white",
        show: _vm.isLoadingFiles,
        "spinner-variant": "primary",
        blur: "0",
        opacity: ".75",
        rounded: "sm"
      }
    },
    [
      _c("div", { staticClass: "row", attrs: { id: "dashboard" } }, [
        _c(
          "div",
          { staticClass: "col-12 mb-2" },
          [
            !_vm.isAguasAndinas
              ? _c("FilesFilters", {
                  attrs: {
                    value: _vm.filters,
                    onChange: _vm.onChangeFilters,
                    clear: _vm.clearFilters,
                    "default-date": _vm.defaultDateRange
                  }
                })
              : _vm._e(),
            _vm.isAguasAndinas
              ? _c("Filters", {
                  attrs: { "default-date": _vm.defaultDateRange },
                  on: { "on-server-filters-change": _vm.onChangeFilters }
                })
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("BarFilesByState", {
                ref: "by-state-and-date",
                attrs: { id: "by-state-and-date" },
                on: { "selected-card": _vm.handleSelectedCard }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "col-12 col-md-4" },
          [
            _c("DonutsFilesByCreationState", {
              ref: "by-state",
              attrs: { id: "by-state" },
              on: { "selected-card": _vm.handleSelectedCard }
            })
          ],
          1
        )
      ]),
      _vm.isAguasAndinas
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-3" },
              [
                _c("VencidoEnXDias", {
                  ref: "by-expirations-1",
                  class: { "bg-gray": _vm.selectedCard === "by-expirations-1" },
                  attrs: { id: "by-expirations-1", from: 1, to: 90 },
                  on: { "selected-card": _vm.handleSelectedCard }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-3" },
              [
                _c("VencenEnXDias", {
                  ref: "by-expirations-2",
                  class: { "bg-gray": _vm.selectedCard === "by-expirations-2" },
                  attrs: { id: "by-expirations-2", from: 0, to: 7 },
                  on: { "selected-card": _vm.handleSelectedCard }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-3" },
              [
                _c("VencenEnXDias", {
                  ref: "by-expirations-3",
                  class: { "bg-gray": _vm.selectedCard === "by-expirations-3" },
                  attrs: { id: "by-expirations-3", from: 8, to: 15 },
                  on: { "selected-card": _vm.handleSelectedCard }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-3" },
              [
                _c("VencenEnXDias", {
                  ref: "by-expirations-4",
                  class: { "bg-gray": _vm.selectedCard === "by-expirations-4" },
                  attrs: { id: "by-expirations-4", from: 15, to: 30 },
                  on: { "selected-card": _vm.handleSelectedCard }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "div",
            { staticClass: "col-12 mt-2" },
            [
              _c(
                "b-card",
                {
                  staticClass: "card-congratulation-medal",
                  staticStyle: { "min-height": "182px" }
                },
                [
                  _c("FilesHeader", {
                    attrs: { exportable: !this.isExportingFiles && true },
                    on: { "export-list": _vm.exportList }
                  }),
                  _vm.isLoadingFiles
                    ? _c("feather-icon", {
                        staticClass: "spinner margin-auto",
                        attrs: { icon: "SettingsIcon", size: "15" }
                      })
                    : _vm._e(),
                  _vm._l(_vm.files, function(file) {
                    return _c("FileRow", {
                      key: file.febosId,
                      ref: "file-row-" + file.febosId,
                      refInFor: true,
                      attrs: {
                        id: "file-row-" + file.febosId,
                        file: file,
                        "on-general-files": true,
                        "select-file": _vm.selectFile
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function(file) {
                              return [
                                _c(
                                  "FileOptions",
                                  {
                                    ref: "file-options-" + file.febosId,
                                    refInFor: true,
                                    attrs: {
                                      file: file.file,
                                      "select-file": _vm.selectFile
                                    }
                                  },
                                  [
                                    _c("template", { slot: "action-list" }, [
                                      _c("span")
                                    ])
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  })
                ],
                2
              ),
              _c("FilesPagination", {
                attrs: { show: _vm.files.length },
                model: {
                  value: _vm.page,
                  callback: function($$v) {
                    _vm.page = $$v
                  },
                  expression: "page"
                }
              })
            ],
            1
          ),
          _c("PopUpGeneralDetailFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpBinnacleFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpParticipantsFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpTimelineFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpReferencesFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          }),
          _c("PopUpTicketFile", {
            attrs: { file: _vm.selectedFile },
            on: { reload: _vm.reload }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }